var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 100 170",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.8208,170c-4.0263-0.0009-7.8873-1.6061-10.7339-4.4626L4.4452,95.6746 c-5.9269-5.9475-5.9269-15.5885,0-21.5361L74.0868,4.2757c6.0312-5.8438,15.6425-5.6764,21.4679,0.3738 c5.6827,5.9023,5.6827,15.26,0,21.1622L36.647,84.9066l58.9077,59.0948c5.9283,5.9488,5.9269,15.5923-0.0032,21.5394 C92.7052,168.3953,88.8457,169.9992,84.8208,170z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.9b160edd259c65e60daec2cc429d37af.svg";
export { ForwardRef as ReactComponent };